import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse, Partner, PartnerLogo } from '../types';

const PROMO_URL = '/v2/promos';
const PROMO_LOGOS_URL = '/v2/promo-logos';

class PromoService {
  static get(id: number, config?: AxiosRequestConfig): Promise<DataResponse<Partner>> {
    return axios.get(`${PROMO_URL}/${id}`, config);
  }

  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<Partner>> {
    return axios.get(PROMO_URL, config);
  }

  static create(data: Partner, config?: AxiosRequestConfig): Promise<DataResponse<Partner>> {
    return axios.post(PROMO_URL, data, config);
  }

  static patch(data: Partial<Partner>, config?: AxiosRequestConfig): Promise<DataResponse<Partner>> {
    return axios.patch(`${PROMO_URL}/${data.id}`, data, config);
  }

  static uploadLogo(data: FormData): Promise<DataResponse<PartnerLogo>> {
    return axios.post(PROMO_LOGOS_URL, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export { PromoService };
